import { PoolButton } from '@synergy/components';
import { ReactElement, ReactNode } from 'react';
import { Stack, StackProps } from '@mui/material';

export interface SettingsItemProps extends StackProps {
    action: ReactNode;
    disabled: boolean;
    onClick: () => void;
}

export const SettingsItem = (props: SettingsItemProps): ReactElement => {
    const { action, disabled, onClick, children, ...stackProps } = props;

    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={3} {...stackProps}>
            {children}
            <PoolButton
                styleType="firstLevel"
                variant="contained"
                disabled={disabled}
                onClick={onClick}
                sx={{ minWidth: 162 }}
            >
                {action}
            </PoolButton>
        </Stack>
    );
};
